import { render, staticRenderFns } from "./scbPortal.vue?vue&type=template&id=d21171ea&scoped=true&"
import script from "./scbPortal.vue?vue&type=script&lang=js&"
export * from "./scbPortal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d21171ea",
  null
  
)

export default component.exports